/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as TYPES from './action-types';
import axios from 'axios';
import * as serviceEndPoint from '../../../../../../SharedModules/services/service';

export const setStubInvoiceLoading = (payload) => {
  return {
    type: TYPES.CREATE_STUB_INVOICE_LOADING,
    payload,
  };
};

export const setReabteProgramData = (payload) => {
  return {
    type: TYPES.CREATE_STUB_INVOICE_REBATE_PROGRAM_DATA,
    payload,
  };
};

export const setStubInvoiceFilter = (payload) => {
  return {
    type: TYPES.CREATE_STUB_INVOICE_FILTER,
    payload,
  };
};

export const setUserDefault = (payload) => {
  return {
    type: TYPES.CREATE_STUB_INVOICE_USERDEFAULT,
    payload,
  };
};

export const resetStubInvoiceStore = () => {
  return {
    type: TYPES.CREATE_STUB_INVOICE_RESET_STORE,
  };
};

export const setStubInvoiceFilterValue = (key, value) => {
  return (dispatch, getState) => {
    const currentStubInvoiceFilter = {
      ...getState().sharedState.createStubInvoice.stubInvoiceFilter,
    };
    currentStubInvoiceFilter[key] = value;
    dispatch(setStubInvoiceFilter(currentStubInvoiceFilter));
  };
};

export const getUserDefaults = (values) => async (dispatch, getState) => {
  dispatch(setStubInvoiceLoading(true));
  try {
    const response = await axios.post(
      `${serviceEndPoint.GET_USER_DEFAULTS}?userId=${values}`
    );

    if (response.data && response.data.data) {
      dispatch(setUserDefault(response.data.data));
    } else {
      dispatch(setUserDefault(null));
    }
  } catch (e) {
    dispatch(setUserDefault(null));
  }
  dispatch(setStubInvoiceLoading(false));
};

export const getRebateProgramCode = (values) => async (dispatch) => {
  if (values) {
    dispatch(setStubInvoiceLoading(true));
    try {
      const response = await axios.post(
        `${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`,
        { planType: values }
      );
      if (
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        let newData = [];
        response.data.data.forEach((item) => {
          newData.push({
            label: `${item.rebateProgramCd} | ${item.shortDescr}`,
            value: item.rebateProgramCd,
            ...item,
          });
        });
        dispatch(setReabteProgramData(newData));
      } else {
        dispatch(setReabteProgramData([]));
      }
    } catch (e) {
      dispatch(setReabteProgramData([]));
    }
    dispatch(setStubInvoiceLoading(false));
  }
};

export const createStubInvoiceAPI = (
  values,
  onSuccess = () => {},
  onError = () => {}
) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        serviceEndPoint.CREATE_STUB_INVOICE,
        values
      );

      onSuccess(response.data || null);
    } catch (e) {
      onError(e?.response?.data?.message || null);
    }
  };
};

export const setErrorMessages = (payload) => {
  return {
    type: TYPES.SET_ERROR_MESSAGES,
    payload,
  };
};
